import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Zap, History, SlidersHorizontal, ArrowRight, MapPin, Clock } from 'lucide-react';
import Layout from '../components/Layout';
import { activitiesAPI, authAPI } from '../api/client';
import '../styles/feed.css';

const TILES = [
  { label: 'Discover',      path: '/discover',      bg: '#C8D8F0', color: '#111111' },
  { label: 'Activities',    path: '/activities',    bg: '#D93868', color: '#ffffff' },
  { label: 'Groups',        path: '/groups',        bg: '#52AAD8', color: '#ffffff' },
  { label: 'Calendar',      path: '/calendar',      bg: '#D93868', color: '#ffffff' },
  { label: 'Messages',      path: '/messages',      bg: '#52AAD8', color: '#ffffff' },
  { label: 'Notifications', path: '/notifications', bg: '#C8D8F0', color: '#111111' },
];

const CHIPS = [
  { label: 'Quick Check-in', icon: Zap, path: '/create-activity' },
  { label: 'Recent Plans', icon: History, path: '/activities' },
  { label: 'Find Friends', icon: SlidersHorizontal, path: '/find-friends' },
];

function formatShortDate(d) {
  if (!d) return '';
  return new Date(d).toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
}

export default function Feed() {
  const navigate = useNavigate();
  const [firstName, setFirstName] = useState(() => {
    const stored = localStorage.getItem('displayName');
    return stored ? stored.split(' ')[0] : '';
  });
  const [recent, setRecent] = useState([]);

  useEffect(() => {
    activitiesAPI.getFeed(3).then(r => setRecent((r.data || []).slice(0, 3))).catch(() => {});
    if (!localStorage.getItem('displayName')) {
      authAPI.getMe().then(r => {
        const name = r.data?.display_name;
        if (name) {
          localStorage.setItem('displayName', name);
          setFirstName(name.split(' ')[0]);
        }
      }).catch(() => {});
    }
  }, []);

  return (
    <Layout title="Dashboard">
      <div className="feed-dashboard">
        {/* Welcome */}
        <div className="feed-welcome">
          <h1 className="feed-welcome-heading">Welcome back, {firstName}.</h1>
        </div>

        {/* Quick chips */}
        <div className="feed-chips">
          {CHIPS.map(({ label, icon: Icon, path }) => (
            <button key={label} className="feed-chip" onClick={() => navigate(path)}>
              <Icon size={14} strokeWidth={2.5} />
              {label}
            </button>
          ))}
        </div>

        {/* Tile grid */}
        <div className="feed-tile-grid">
          {TILES.map(({ label, path, bg, color }) => (
            <button
              key={label}
              className="feed-tile"
              style={{ background: bg }}
              onClick={() => navigate(path)}
            >
              <span className="feed-tile-bg-label" style={{ color: `${color}18` }}>{label}</span>
              <div className="feed-tile-footer">
                <span className="feed-tile-label" style={{ color }}>{label}</span>
                <ArrowRight size={14} color={color} opacity={0.5} />
              </div>
            </button>
          ))}
        </div>

        {/* Recent activity */}
        {recent.length > 0 && (
          <div className="feed-recent">
            <div className="feed-recent-header">
              <span className="feed-recent-title">Recent activity</span>
              <button className="feed-recent-all" onClick={() => navigate('/activities')}>
                View all <ArrowRight size={13} />
              </button>
            </div>
            {recent.map(a => (
              <div key={a.id} className="feed-recent-row" onClick={() => navigate(`/activity/${a.id}`)}>
                <div className="feed-recent-dot" />
                <div className="feed-recent-info">
                  <span className="feed-recent-name">{a.title || a.activity_type}</span>
                  <span className="feed-recent-meta">
                    <Clock size={11} /> {formatShortDate(a.start_time)}
                    {a.location_name && <><MapPin size={11} /> {a.location_name}</>}
                  </span>
                </div>
                <ArrowRight size={14} color="var(--text-faint)" />
              </div>
            ))}
          </div>
        )}
      </div>
    </Layout>
  );
}
